import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import Layout from "./components/Layout";
import config from "./config";
import HomePage from "./pages/index";

function App() {
  return (
    <BrowserRouter basename={config.get('BASEPATH')}>
      <Switch>
        <Layout>
          <Route path="/" exact component={HomePage} />
        </Layout>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
